import api from "../../services/api";


export default async function confirmCodfile(idmsg) {
	
	const { data } = await  api.get(`MensajesC/getfilecod/${idmsg}`);
	return  data;
}

